import {createI18n} from "vue-i18n";
import messages from "./messages";

export default createI18n({
    fallbackLocale: 'de_CH',
    locale: window.locale,
    messages,
})
